import joinClassNames from 'classnames';

import styles from './InsuranceCard.module.scss';

type SpotPropT = {
  width: number;
  height: number;
  classNames?: string[];
};

const Spot = ({ height, width, classNames }: SpotPropT): JSX.Element => {
  const containerClassNames = joinClassNames(styles.circle_base, classNames);

  return (
    <div
      style={{
        width,
        height,
      }}
      className={containerClassNames}
    />
  );
};

export default Spot;
